import { COLORS } from '../../../config/designSystem/Colors';
import { ComponentProps } from 'react';
import { MaterialIcons } from '@expo/vector-icons';

const IconComponent = MaterialIcons;
const iconColors = {
  off: COLORS.surface.contrast,
  on: COLORS.border.accent,
};
interface ToggleIconProps extends Omit<ComponentProps<typeof IconComponent>, 'name'> {
  pressed: boolean;
  on: ComponentProps<typeof IconComponent>['name'];
  off: ComponentProps<typeof IconComponent>['name'];
}
const ToggleIcon = ({pressed, on, off, ...props}: ToggleIconProps) => {
  return (
    <IconComponent
      {...props}
      name={pressed ? on : off}
      color={pressed ? iconColors.on : iconColors.off}
    />
  );
};
export default ToggleIcon;
